import Image from "./image";

export default class Artwork {
    regNum: string = '';
    title: string = '';
    rating: number = 0;
    date: string = '';
    isDoubleSided: boolean = false;
    typeOfObject: string = 'Painting';
    keywords: Array<string> = [];
    materials: Array<string> = [];
    support: Array<string> = [];
    backOfWorkMaterials: Array<string> = [];
    measurements: string = '';
    height: number = 0;
    width: number = 0;
    originalImages: Array<Image> = [];
    xLargeImages: Array<Image> = [];
    largeImages: Array<Image> = [];
    mediumImages: Array<Image> = [];
    smallImages: Array<Image> = [];
    xSmallImages: Array<Image> = [];
    thumbnailImages: Array<Image> = [];

    static fromJson(json: any): Artwork {
        const artwork: Artwork = new Artwork();
        artwork.regNum = json.regNum;
        artwork.title = json.title;
        artwork.rating = json.rating;
        artwork.date = json.date;
        artwork.isDoubleSided = json.isDoubleSided;
        artwork.typeOfObject = json.typeOfObject;
        artwork.keywords = json.keywords.map((k: { value: any; }) => k.value);
        artwork.materials = json.materials.map((m: { value: any; }) => m.value);
        artwork.support = json.support.map((s: { value: any; }) => s.value);
        artwork.backOfWorkMaterials = json.backOfWorkMaterials.map((m: { value: any; }) => m.value);
        artwork.measurements = json.measurements;
        artwork.height = json.height;
        artwork.width = json.width;
        if (json.images !== undefined && json.images !== null && json.images.data !== undefined && json.images.data !== null) {
            artwork.originalImages = json.images.data
                .map((i: { attributes: any; }) => i.attributes)
                .map((i: { url: string; height: number; width: number; }) => new Image(i.url, i.height, i.width));
            artwork.xLargeImages = json.images.data
                .filter((i: { attributes: { formats: { xlarge: undefined; }; }; }) => i.attributes.formats.xlarge !== undefined)
                .map((i: { attributes: any; }) => i.attributes.formats.xlarge)
                .map((i: { url: string; height: number; width: number; }) => new Image(i.url, i.height, i.width));
            artwork.largeImages = json.images.data
                .filter((i: { attributes: { formats: { large: undefined; }; }; }) => i.attributes.formats.large !== undefined)
                .map((i: { attributes: any; }) => i.attributes.formats.large)
                .map((i: { url: string; height: number; width: number; }) => new Image(i.url, i.height, i.width));
            artwork.mediumImages = json.images.data
                .filter((i: { attributes: { formats: { medium: undefined; }; }; }) => i.attributes.formats.medium !== undefined)
                .map((i: { attributes: any; }) => i.attributes.formats.medium)
                .map((i: { url: string; height: number; width: number; }) => new Image(i.url, i.height, i.width));
            artwork.smallImages = json.images.data
                .filter((i: { attributes: { formats: { small: undefined; }; }; }) => i.attributes.formats.small !== undefined)
                .map((i: { attributes: any; }) => i.attributes.formats.small)
                .map((i: { url: string; height: number; width: number; }) => new Image(i.url, i.height, i.width));
            artwork.xSmallImages = json.images.data
                .filter((i: { attributes: { formats: { xsmall: undefined; }; }; }) => i.attributes.formats.xsmall !== undefined)
                .map((i: { attributes: any; }) => i.attributes.formats.xsmall)
                .map((i: { url: string; height: number; width: number; }) => new Image(i.url, i.height, i.width));
            artwork.thumbnailImages = json.images.data
                .filter((i: { attributes: { formats: { thumbnail: undefined; }; }; }) => i.attributes.formats.thumbnail !== undefined)
                .map((i: { attributes: any; }) => i.attributes.formats.thumbnail)
                .map((i: { url: string; height: number; width: number; }) => new Image(i.url, i.height, i.width));
        }
        return artwork;
    }

    equals(otherArtwork: Artwork): boolean {
        const thisArtwork = JSON.parse(JSON.stringify(this));
        const thatArtwork = JSON.parse(JSON.stringify(otherArtwork));
        if (Object.keys(thisArtwork).length !== Object.keys(thatArtwork).length) return false;
        if (JSON.stringify(Object.keys(thisArtwork)) !== JSON.stringify(Object.keys(thatArtwork))) return false;
        return Object.keys(this).every(key => JSON.stringify(thisArtwork[key]) === JSON.stringify(thatArtwork[key]));
    }

}